// extracted by mini-css-extract-plugin
export var container = "_du-1";
export var editor = "_du-2";
export var resizable = "_du-3";
export var wrapper = "_du-0";